import React from 'react';
import classNames from 'classnames';
import { Icon } from 'ui';
import CriterionRow from '../_shared/CriterionRow';
import QuestionMetadata from './QuestionMetadata';

const newIcons = [
  'rating-warn',
  'rating-wrench',
  'rating-check',
  'rating-thumbs-up',
  'rating-trophy',
];
class PracticeQuestionInsights extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      messageVisible: false,
    };
    this.toggleMessageVisibility = this.toggleMessageVisibility.bind(this);
  }

  toggleMessageVisibility() {
    this.setState(state => ({ messageVisible: !state.messageVisible }));
  }

  renderCriteriaHeader = ratingOptions => {
    return newIcons.map(iconName => (
      <span key={iconName}>
        <Icon name={iconName} />
      </span>
    ));
  };

  render() {
    const {
      questionType,
      questionPrompt,
      ratingOptions,
      criteriaData,
      questionMetadata,
    } = this.props.data;
    const { messageVisible } = this.state;
    const iconStyles = classNames('PracticeQuestionInsights-rotatingIcon', {
      'PracticeQuestionInsights-rotatingIcon--rotated': messageVisible,
    });
    const messageStyles = classNames('PracticeQuestionInsights-message', {
      'PracticeQuestionInsights-message--visible': messageVisible,
    });

    return (
      <div className="Module Module--bordered PracticeQuestionInsights">
        <div className="PracticeQuestionInsights-description">
          <div className="c-brand-gray-dark fz-base">{questionType}</div>
          <div>{questionPrompt}</div>
          {questionMetadata && (
            <div className={messageStyles}>
              <QuestionMetadata
                data={questionMetadata}
                questionType={questionType}
              />
            </div>
          )}
          {questionMetadata && (
            <div
              className="PracticeQuestionInsights-messageToggle c-brand-blue fz-base"
              onClick={this.toggleMessageVisibility}
              onKeyDown={e =>
                e.key === 'Enter' && this.toggleMessageVisibility()
              }
            >
              <span className={iconStyles}>
                <Icon name="caret_down" />
              </span>
              {messageVisible
                ? t('common.toggle.hide')
                : t('common.toggle.show')}{' '}
              {t('practice.insights.question.incoming')}{' '}
              {questionType.split(' ')[0]}
            </div>
          )}
        </div>
        <table>
          <tbody>
            <tr className="PracticeQuestionInsights-headerRow fw-b">
              <th className="PracticeQuestionInsights-headerRow--criteria pl-20">
                {t('insights.criterion.headers.criteria')}
              </th>
              <th>{t('insights.criterion.headers.total_ratings')}</th>
              <th className="PracticeQuestionInsights-headerRow--newRatingScale">
                {this.renderCriteriaHeader(ratingOptions)}
              </th>
            </tr>
            {criteriaData.map(criterion => (
              <CriterionRow
                criterion={criterion}
                key={criterion.name}
                ratingOptions={ratingOptions}
              />
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default PracticeQuestionInsights;
